export class TRP_COMPANY_SETUP {
    public COMP_ID!: number;
    public TALLY_LINK!: string;
    public TALLY_COMP_NAME!: string;
    public PREPAID_SALES!: string;
    public TOPAY_CR_SALES!: string;
    public TOPAY_CN_SALES!: string;
    public TBB_SALES!: string;
    public PARTY_LEDGER_GROUP!: string;
}
